import { ROLE_LABELS } from "@/constants/workflow";

const ORDER = ["design", "bim", "production", "qaqc", "logistics", "site", "planning"];

/** Group tasks by department, then by user — used by the PM/Admin "All" view. */
export function groupByDepartmentAndUser(tasks) {
  const departments = new Map();

  const bucket = (deptKey, person, task) => {
    if (!departments.has(deptKey))
      departments.set(deptKey, { key: deptKey, label: ROLE_LABELS[deptKey] || "No department", people: new Map() });
    const dept = departments.get(deptKey);
    if (!dept.people.has(person.id))
      dept.people.set(person.id, { id: person.id, name: person.name, tasks: [] });
    dept.people.get(person.id).tasks.push(task);
  };

  tasks.forEach((task) => {
    if (!task.assignees.length) {
      bucket("none", { id: "none", name: "Unassigned" }, task);
      return;
    }
    task.assignees.forEach((person) => {
      const depts = person.departments?.length ? person.departments : ["none"];
      depts.forEach((dept) => bucket(dept, person, task));
    });
  });

  return [...departments.values()]
    .map((dept) => ({
      ...dept,
      people: [...dept.people.values()].sort((a, b) => a.name.localeCompare(b.name)),
      count: [...dept.people.values()].reduce((sum, p) => sum + p.tasks.length, 0),
    }))
    .sort((a, b) => {
      const ai = ORDER.indexOf(a.key);
      const bi = ORDER.indexOf(b.key);
      return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi);
    });
}
